import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PageLayout from "components/layout/page-layout";
import ActionButton from "components/table/action-btn";
import Table, { tableHeader } from "components/table";
import { oneLine, tagsList } from "components/table/table-parts";
import { IconTrash } from "@tabler/icons-react";
import { deleteTemplate } from "api/template";
import { useSharedState } from "state";
import DangerModal from "components/modal/danger";

export default function Templates() {
  const { templates, getTemplatesData, notify } = useSharedState();

  const navigate = useNavigate();

  const [templateToDelete, setTemplateToDelete] = useState<number>(0);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const deleteDanger = "Вы действительно хотите удалить шаблон?";

  useEffect(() => {
    getTemplatesData();
  }, []);

  const onTemplateDelete = async () => {
    setFormLoading(true);

    try {
      await deleteTemplate(templateToDelete);
      notify("Шаблон удалён", "success");

      getTemplatesData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при удалении шаблона");
    } finally {
      setFormLoading(false);
      setTemplateToDelete(0);
    }
  };

  const templatesTableHeaders: tableHeader[] = [
    { header_text: "Название шаблона", narrow: false, wrap: false },
    { header_text: "Должности утверждающих пользователей", narrow: false, wrap: false },
    { header_text: "Филиалы", narrow: false, wrap: false },
    { header_text: "Тип модуля", narrow: false, wrap: false },
    { header_text: "Действия", narrow: false, wrap: false },
  ];

  const templatesList = (
    <>
      {templates.map((template, index) => (
        <tr key={index}>
          <td>{oneLine(template.name)}</td>
          <td>{tagsList(template.positions?.map((item) => item.position))}</td>
          <td>{tagsList(template.locations?.map((item) => item.location))}</td>
          <td>{oneLine(template.type)}</td>
          <td>
            <div className="btn-list flex-nowrap">
              <ActionButton
                icon={<IconTrash className="icon" />}
                title="Удалить"
                action={() => setTemplateToDelete(template.template_id)}
                color={"danger"}
                modal={true}
                modal_id="#modal-delete-template"
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );

  const templatesTable = Table(templatesTableHeaders, templatesList, false);

  const additionalButtons = (
    <div className="d-flex flex-wrap gap-2 w-full md-w-fit">
      <button className="btn btn-primary grow" onClick={() => navigate("positions")} disabled={isFormLoading}>
        Список должностей
      </button>
      <button className="btn btn-primary grow" onClick={() => navigate("locations")} disabled={isFormLoading}>
        Список филиалов
      </button>
      <button className="btn btn-primary grow" onClick={() => navigate("companies")} disabled={isFormLoading}>
        Список юр. лиц
      </button>
      <button className="btn btn-primary grow" onClick={() => navigate("budget-list")} disabled={isFormLoading}>
        Список статей бюджета
      </button>
    </div>
  );

  return (
    <>
      <PageLayout
        children={templatesTable}
        header={"Шаблоны"}
        subheaderText={`Количество шаблонов: ${templates.length}`}
        search={false}
        filters={false}
        buttonText={"Новый шаблон"}
        buttonAction={() => navigate("create")}
        additionalButton={additionalButtons}
      />
      <DangerModal
        modal_id="modal-delete-template"
        dangerDescription={deleteDanger}
        cancel={() => setTemplateToDelete(0)}
        confirm={onTemplateDelete}
      />
      <Outlet />
    </>
  );
}
